export default "__VITE_ASSET__zqBvNYLq__"